<div class="padding">
  <mat-card>
    <mat-card-content>
      <div class="table-container">
        <h3>{{ 'automationMonitors.automationMonitor' | transloco }}</h3>
        <mat-tab-group animationDuration="0ms">
          <mat-tab>
            <ng-template mat-tab-label>
              <span [matBadge]="numFailedMonitors"
                matBadgeSize="small"
                matBadgeOverlap="false"
              [matBadgeHidden]="numFailedMonitors < 1">{{ 'automationMonitors.scheduled' | transloco }}</span>
            </ng-template>
            <app-scheduled-monitors></app-scheduled-monitors>
          </mat-tab>
          <mat-tab [label]="'automationMonitors.queues' | transloco">
            <app-queue-monitors-filter></app-queue-monitors-filter>
            <app-queue-monitors></app-queue-monitors>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-card-content>
  </mat-card>
</div>
